import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/layout/Header';

const CreatePage: React.FC = () => {
  const [scriptType, setScriptType] = useState('modern');
  const [duration, setDuration] = useState('3min');
  const [creativity, setCreativity] = useState(5);
  const [keywords, setKeywords] = useState('');
  const [isGenerating, setIsGenerating] = useState(false);
  const [generatedScript, setGeneratedScript] = useState<string | null>(null);

  const handleGenerate = async () => {
    setIsGenerating(true);
    try {
      // 调用真实的后端API
      const response = await fetch('http://localhost:3002/api/scripts/generate', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          keywords: keywords || '默认剧情',
          genre: scriptType,
          duration: duration,
          creativity: creativity
        }),
      });

      const result = await response.json();

      if (result.success) {
        // 将API返回的数据转换为剧本格式
        const script = result.data;
        let scriptContent = `# ${script.title}

## 故事大纲
${script.description}

## 剧本信息
- **类型：** ${script.genre}
- **时长：** ${script.duration}
- **关键词：** ${script.keywords}

`;

        // 添加场景
        script.scenes.forEach((scene: any, index: number) => {
          scriptContent += `
## 场景${index + 1}：${scene.title}
**时间：** 根据剧情设定
**人物：** 根据剧情需要

*${scene.description}*

// 此处可添加具体对话和动作描述

`;
        });

        setGeneratedScript(scriptContent);
      } else {
        // API调用失败，使用备用生成逻辑
        throw new Error('API调用失败');
      }
    } catch (error) {
      console.log('API调用失败，使用备用生成逻辑:', error);
      // 备用生成逻辑（原有代码）
      setTimeout(() => {
      let scriptContent = '';

      // 根据剧本类型生成不同内容
      switch(scriptType) {
        case 'fantasy':
          scriptContent = `
# 修仙奇缘

## 故事大纲
普通少年林风在一次意外中获得神秘传承，从此踏上修仙之路，在修真世界中历经磨难，最终成为一代宗师。

## 场景一：意外传承
**时间：** 夜晚
**人物：** 林风（16岁，普通少年）、神秘老人

*林风在山中迷路，遇到一位受伤的老人*

林风：老爷爷，您受伤了？我帮您包扎一下吧。

神秘老人：（虚弱）孩子，你心性纯良，老夫将这枚传承玉佩赠予你。

*老人将一枚发光的玉佩交给林风，随后消失*

林风：（惊讶）老爷爷？您去哪了？

*玉佩突然发出光芒，林风感到一股暖流传遍全身*

## 场景二：初入修仙
**时间：** 三个月后
**人物：** 林风、宗门长老

*林风来到修仙宗门报名*

长老：（测试林风）不错，你身负灵根，可以入门修行。

林风：（兴奋）真的吗？我真的可以修仙？

长老：但修仙之路艰险，你可要想清楚了。

林风：我已下定决心，无论多难都要走下去！

## 场景三：修炼突破
**时间：** 一年后
**人物：** 林风、师兄们

*林风在练功房努力修炼*

师兄甲：林师弟，你这进步也太快了！

林风：（谦虚）师兄过奖了，我只是比较努力而已。

师兄乙：再过不久，你就能突破到下一个境界了。

*林风感受到体内灵力涌动，突然突破，金光四射*

## 结局
十年后，林风已经成为宗门最年轻的长老，守护着这片他热爱的土地。修仙之路虽然孤独，但他找到了属于自己的道。
          `;
          break;

        case 'ancient':
          scriptContent = `
# 宫墙情缘

## 故事大纲
现代女孩意外穿越到古代，成为丞相之女，与皇帝之间展开了一段跨越时空的爱情故事。

## 场景一：意外穿越
**时间：** 现代，夜晚
**人物：** 苏婉（25岁，现代白领）

*苏婉在博物馆参观一件古董时，突然触电*

苏婉：（头晕）这是怎么回事？...

*苏婉醒来发现自己躺在古色古香的房间里*

丫鬟：（焦急）小姐，您终于醒了！老爷很担心您。

苏婉：（困惑）小姐？老爷？这是哪里？

## 场景二：宫廷初见
**时间：** 三天后，皇宫
**人物：** 苏婉、皇帝、众大臣

*苏婉第一次参加宫廷宴会*

皇帝：（好奇）听说苏丞相之女近日病愈，今日一见果然不同凡响。

苏婉：（行礼）陛下过奖了。

皇帝：（被苏婉的现代举止吸引）你...似乎与其他女子不太一样。

苏婉：（紧张）妾身...妾身只是大病初愈，性情有些变化。

## 场景三：感情发展
**时间：** 一个月后，御花园
**人物：** 苏婉、皇帝

*皇帝在御花园偶遇苏婉*

皇帝：朕发现你懂很多新奇的事物，能告诉朕你是从哪里学来的吗？

苏婉：（犹豫）陛下，有些事情说来您可能不信。

皇帝：朕愿意相信你，因为朕从未对任何人有过这样的感觉。

*两人相视，气氛暧昧*

## 结局
最终，皇帝接受了苏婉来自未来的真相，两人用爱跨越了时空的障碍。苏婉用现代知识帮助皇帝治理国家，开创了盛世王朝。
          `;
          break;

        case 'comedy':
          scriptContent = `
# 爆笑办公室

## 故事大纲
职场新人小张在奇葩公司里的各种搞笑经历，与搞笑同事一起创造欢乐日常。

## 场景一：奇葩面试
**时间：** 上午
**人物：** 小张（应届生）、面试官

*小张来到一家看起来很普通的公司面试*

面试官：（严肃）我们公司最注重什么？

小张：（紧张）是...是团队合作？

面试官：（突然大笑）错！是开心！我们公司每天必须笑够三小时！

小张：（困惑）啊？这是什么规定？

面试官：当然！我们的口号是：笑着工作，笑着下班！

## 场景二：搞笑同事
**时间：** 第一天上班
**人物：** 小张、王同事、李同事

*小张认识了办公室的奇葩同事*

王同事：（戴着夸张的领带）小张，欢迎加入我们疯人院！

李同事：（头顶着玩具恐龙）午饭时间到了！今天吃恐龙主题餐！

小张：（震惊）这家公司...真的正常吗？

王同事：正常？正常两个字都不在我们的字典里！

## 场景三：搞笑会议
**时间：** 下午
**人物：** 全体员工、老板

*公司开会讨论新项目*

老板：（戴着小丑鼻子）大家今天有什么好点子？

王同事：我们可以开发一个会讲冷笑话的软件！

李同事：不如开发一个自动挠痒痒机器人！

小张：（小声）这公司真的能赚钱吗？

老板：当然！我们的产品就是快乐！

## 结局
小张逐渐爱上了这家奇葩公司，发现原来工作可以这么快乐。在这里，笑声就是最大的生产力。
          `;
          break;

        case 'suspense':
          scriptContent = `
# 午夜凶铃

## 故事大纲
侦探陈明调查一系列离奇死亡案件，发现所有受害者都接到了一个神秘的电话。

## 场景一：发现案件
**时间：** 深夜
**人物：** 陈明（40岁，资深侦探）、小王（年轻警员）

*陈明在犯罪现场调查*

小王：（紧张）陈队，这已经是第三起了，死者都是接到神秘电话后死亡。

陈明：（严肃）而且死者脸上都带着诡异的微笑。

小王：最奇怪的是，所有死者的手机都显示同一个未知号码。

陈明：这个号码...查过了吗？

小王：查过了，根本不存在这个号码！

## 场景二：深入调查
**时间：** 第二天
**人物：** 陈明、神秘老者

*陈明走访调查时遇到一位神秘老者*

老者：（神秘）年轻人，你在查那些死亡案件吧？

陈明：（警惕）您知道什么？

老者：有些事情不知道比知道要好...那个号码来自另一个世界。

陈明：另一个世界？您在说什么？

老者：（摇头）有些真相注定无法被揭开...你最好放弃调查。

*老者转身消失*

## 场景三：真相逼近
**时间：** 午夜
**人物：** 陈明、神秘声音

*陈明独自一人调查，手机突然响起*

神秘声音：（诡异）你很执着嘛...侦探先生。

陈明：（冷静）你是谁？这些案子和你有关？

神秘声音：他们只是看到了不该看的东西...就像你现在一样。

陈明：我倒要看看你能把我怎么样！

*电话挂断，陈明感到一阵寒意*

## 结局
陈明最终发现这些死亡与一个百年前的诅咒有关，但当他想要揭开真相时，自己的手机也响起了那个熟悉的铃声...
          `;
          break;

        case 'youth':
          scriptContent = `
# 青春校园

## 故事大纲
高中生小雨在高考前夕面临着友情、爱情和学业的三重压力，在迷茫中找到自己的方向。

## 场景一：课堂风波
**时间：** 上午，高三教室
**人物：** 林小雨（18岁，高三学生）、张老师、同学们

*数学课堂上，小雨在偷偷写小说*

张老师：（严厉）林小雨！又在做什么？

小雨：（慌张）没...没什么，老师。

张老师：（走过来）让我看看你在写什么...

*同学们起哄，小雨脸红*

张老师：（拿起笔记本）写得还不错，但现在应该专注于高考！

小雨：（小声）可是老师，我真的很喜欢写作...

## 场景二：友情考验
**时间：** 午休时间
**人物：** 小雨、小美（闺蜜）、小强（暗恋对象）

*小雨和小美在食堂吃饭*

小美：你真的要参加那个写作比赛吗？高考就剩三个月了！

小雨：（犹豫）我知道，但这是我的梦想...

小强：（走过来）听说你要参加写作比赛？我觉得你一定能赢！

小雨：（脸红）谢谢...

小美：（翻白眼）某些人就知道说好听的。

小强：（尴尬）我...我是认真的！

## 场景三：内心挣扎
**时间：** 晚上，小雨房间
**人物：** 小雨、妈妈

*小雨在房间里学习，妈妈敲门进来*

妈妈：还在学习吗？不要太累了。

小雨：（苦恼）妈，我有点迷茫...

妈妈：怎么了孩子？

小雨：我不知道该选择梦想还是现实...写作比赛很重要，但高考也很重要。

妈妈：（温和）人生不是选择题，而是如何平衡的艺术。

小雨：（思考）您的意思是...

妈妈：追求梦想没错，但也要为自己的选择负责。

## 结局
最终，小雨决定参加写作比赛，同时也没有放弃高考。虽然过程很辛苦，但她学会了如何平衡梦想和现实，这成为了她人生中最宝贵的财富。
          `;
          break;

        default: // modern
          scriptContent = `
# 都市爱情短剧

## 故事大纲
年轻的职场女孩小林在一次偶然的机会中遇到了神秘的咖啡师阿杰，两人因一杯特别的咖啡结缘，展开了一段温暖的爱情故事。

## 场景一：咖啡厅
**时间：** 下午3点
**人物：** 小林（25岁，职场新人）、阿杰（28岁，咖啡师）

*小林匆忙走进咖啡厅，看起来很疲惫*

阿杰：（微笑）今天想喝点什么？

小林：（叹气）来杯最提神的吧，今天工作太累了。

阿杰：我给你调一杯特别的，保证让你精神焕发。

*阿杰开始精心调制咖啡，小林好奇地观察*

## 场景二：咖啡厅外的偶遇
**时间：** 一周后，傍晚
**人物：** 小林、阿杰

*小林在咖啡厅外遇到正在休息的阿杰*

小林：上次你调的咖啡真的很棒，谢谢你。

阿杰：（害羞）其实我有个秘密，我的咖啡能让人看到美好的未来。

小林：（好奇）真的吗？那你能看到我的未来吗？

阿杰：（深情地看着小林）我看到我们的未来...一起经营这家咖啡厅。

## 场景三：咖啡厅的夜晚
**时间：** 一个月后，夜晚
**人物：** 小林、阿杰

*咖啡厅打烊后，两人一起整理*

小林：这一个月来，我发现自己越来越喜欢这里了。

阿杰：是因为咖啡，还是因为...我？

小林：（脸红）也许都有吧。

*两人相视而笑，温暖的音乐响起*

## 结局
一年后，小林辞去了原来的工作，和阿杰一起经营着这家充满爱意的咖啡厅。他们的故事，就像那杯特别的咖啡一样，温暖而美好。
          `;
      }

      setGeneratedScript(scriptContent);
      setIsGenerating(false);
    }, 2000);
    }
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <Header />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {/* 面包屑导航 */}
        <nav className="flex items-center space-x-2 text-sm text-gray-600 mb-8">
          <Link to="/" className="hover:text-purple-600">首页</Link>
          <span>/</span>
          <span className="text-gray-900">创作中心</span>
        </nav>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          {/* 左侧控制面板 */}
          <div className="lg:col-span-1">
            <div className="bg-white rounded-xl shadow-lg p-6 sticky top-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-6">AI剧本生成器</h2>

              {/* 剧本类型 */}
              <div className="mb-6">
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  剧本类型
                </label>
                <select
                  value={scriptType}
                  onChange={(e) => setScriptType(e.target.value)}
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-purple-500"
                >
                  <option value="modern">现代都市</option>
                  <option value="ancient">古装言情</option>
                  <option value="comedy">喜剧搞笑</option>
                  <option value="suspense">悬疑推理</option>
                  <option value="fantasy">奇幻玄幻</option>
                  <option value="youth">青春校园</option>
                </select>
              </div>

              {/* 剧本时长 */}
              <div className="mb-6">
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  预计时长
                </label>
                <select
                  value={duration}
                  onChange={(e) => setDuration(e.target.value)}
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-purple-500"
                >
                  <option value="1min">1分钟</option>
                  <option value="3min">3分钟</option>
                  <option value="5min">5分钟</option>
                  <option value="10min">10分钟</option>
                </select>
              </div>

              {/* 创意程度 */}
              <div className="mb-6">
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  创意程度: {creativity}/10
                </label>
                <input
                  type="range"
                  min="1"
                  max="10"
                  value={creativity}
                  onChange={(e) => setCreativity(parseInt(e.target.value))}
                  className="w-full h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer"
                />
                <div className="flex justify-between text-xs text-gray-500 mt-1">
                  <span>保守</span>
                  <span>平衡</span>
                  <span>创新</span>
                </div>
              </div>

              {/* 关键词输入 */}
              <div className="mb-6">
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  关键词描述
                </label>
                <textarea
                  value={keywords}
                  onChange={(e) => setKeywords(e.target.value)}
                  placeholder="描述您想要的剧情内容，比如：职场、咖啡厅、偶遇、温暖..."
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-purple-500 h-24 resize-none"
                />
              </div>

              {/* 生成按钮 */}
              <button
                onClick={handleGenerate}
                disabled={isGenerating}
                className="w-full py-3 bg-gradient-to-r from-purple-600 to-purple-800 text-white font-semibold rounded-lg hover:from-purple-700 hover:to-purple-900 disabled:opacity-50 disabled:cursor-not-allowed transition-all duration-200"
              >
                {isGenerating ? (
                  <div className="flex items-center justify-center">
                    <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                      <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                    </svg>
                    AI正在生成剧本...
                  </div>
                ) : (
                  '🎭 生成剧本'
                )}
              </button>

              {/* 快速模板 */}
              <div className="mt-6 pt-6 border-t border-gray-200">
                <h3 className="text-sm font-medium text-gray-700 mb-3">快速模板</h3>
                <div className="space-y-2">
                  <button
                    onClick={() => {
                      setScriptType('modern');
                      setKeywords('职场、办公室、奋斗、成长、团队合作');
                      alert('已选择职场励志故事模板！');
                    }}
                    className="w-full text-left px-3 py-2 text-sm bg-purple-50 text-purple-700 rounded-lg hover:bg-purple-100 transition-colors"
                  >
                    💼 职场励志故事
                  </button>
                  <button
                    onClick={() => {
                      setScriptType('modern');
                      setKeywords('爱情、相遇、甜蜜、浪漫、咖啡厅');
                      alert('已选择甜蜜爱情故事模板！');
                    }}
                    className="w-full text-left px-3 py-2 text-sm bg-orange-50 text-orange-700 rounded-lg hover:bg-orange-100 transition-colors"
                  >
                    💕 甜蜜爱情故事
                  </button>
                  <button
                    onClick={() => {
                      setScriptType('comedy');
                      setKeywords('搞笑、日常、朋友、幽默、意外');
                      alert('已选择搞笑日常故事模板！');
                    }}
                    className="w-full text-left px-3 py-2 text-sm bg-green-50 text-green-700 rounded-lg hover:bg-green-100 transition-colors"
                  >
                    😄 搞笑日常故事
                  </button>
                </div>
              </div>
            </div>
          </div>

          {/* 右侧预览区域 */}
          <div className="lg:col-span-2">
            {generatedScript ? (
              <div className="bg-white rounded-xl shadow-lg p-6">
                <div className="flex items-center justify-between mb-6">
                  <h3 className="text-xl font-semibold text-gray-900">生成的剧本</h3>
                  <div className="flex space-x-2">
                    <button
                      onClick={() => {
                        alert('剧本编辑功能开发中...\n\n将提供：\n• 剧本格式化\n• AI写作建议\n• 协作编辑功能');
                      }}
                      className="px-4 py-2 bg-purple-600 text-white rounded-lg hover:bg-purple-700 transition-colors"
                    >
                      编辑剧本
                    </button>
                    <button
                      onClick={() => {
                        const scriptContent = generatedScript || '请先生成剧本';
                        const blob = new Blob([scriptContent], { type: 'text/plain;charset=utf-8' });
                        const url = URL.createObjectURL(blob);
                        const a = document.createElement('a');
                        a.href = url;
                        a.download = 'AI短剧剧本.txt';
                        document.body.appendChild(a);
                        a.click();
                        document.body.removeChild(a);
                        URL.revokeObjectURL(url);
                        alert('剧本已导出为文本文件！');
                      }}
                      className="px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors"
                    >
                      导出剧本
                    </button>
                  </div>
                </div>

                <div className="prose max-w-none">
                  <pre className="whitespace-pre-wrap font-mono text-sm text-gray-800 bg-gray-50 p-4 rounded-lg">
                    {generatedScript}
                  </pre>
                </div>

                <div className="mt-6 pt-6 border-t border-gray-200">
                  <h4 className="font-medium text-gray-900 mb-3">下一步操作</h4>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <button
                      onClick={() => window.location.href = '/character-setting'}
                      className="px-4 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
                    >
                      🎨 设定角色
                    </button>
                    <button
                      onClick={() => window.location.href = '/storyboard'}
                      className="px-4 py-3 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 transition-colors"
                    >
                      🎬 分镜设计
                    </button>
                  </div>
                </div>
              </div>
            ) : (
              <div className="bg-white rounded-xl shadow-lg p-12 text-center">
                <div className="w-24 h-24 bg-purple-100 rounded-full flex items-center justify-center mx-auto mb-6">
                  <span className="text-4xl">🎭</span>
                </div>
                <h3 className="text-2xl font-semibold text-gray-900 mb-4">
                  开始您的AI创作之旅
                </h3>
                <p className="text-gray-600 mb-8">
                  在左侧设置您的创作需求，AI将为您生成专属的短剧剧本
                </p>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4 text-left">
                  <div className="p-4 bg-purple-50 rounded-lg">
                    <div className="text-purple-600 mb-2">🎯</div>
                    <h4 className="font-medium text-gray-900">智能匹配</h4>
                    <p className="text-sm text-gray-600">根据关键词智能生成符合需求的剧本</p>
                  </div>
                  <div className="p-4 bg-orange-50 rounded-lg">
                    <div className="text-orange-600 mb-2">⚡</div>
                    <h4 className="font-medium text-gray-900">快速生成</h4>
                    <p className="text-sm text-gray-600">只需几秒钟，即可获得完整剧本</p>
                  </div>
                  <div className="p-4 bg-green-50 rounded-lg">
                    <div className="text-green-600 mb-2">🎨</div>
                    <h4 className="font-medium text-gray-900">个性定制</h4>
                    <p className="text-sm text-gray-600">支持多种风格和创意程度调节</p>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CreatePage;